import api from './index';

const postEmail = (data) => api.post('/email', data);

export default postEmail;
